import Nullstack from 'nullstack';
export default function IconBracketsContainStart({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brackets-contain-start",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 4h-4v16h4"
  }), "   ", Nullstack.element("path", {
    d: "M18 16h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M14 16h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M10 16h-.01"
  }), " ");
}